<template lang="html">
  <div
    class="poster banner-home-ui"
    :class="{
      noBanner: !beforeLoading && (!newPosters || newPosters.length == 0),
      beforeLoading: beforeLoading
    }"
  >
    <slot></slot>
    <swipe
      :auto="5000"
      :show-indicators="newPosters && newPosters.length > 1"
      v-if="newPosters && newPosters.length > 0"
    >
      <swipe-item v-for="(item, index) in newPosters" :key="index">
        <a :href="item.link" @click="clickImage(index, item)">
          <img v-lazy="$$viewImage(item.img)" />
        </a>
      </swipe-item>
    </swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'mint-ui'

export default {
  PAGE_ID: '288987',
  props: {
    posters: {
      type: Array,
      default() {
        return []
      }
    },
    citycode: Number | String,
    beforeLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickImage(index, item) {
      const uid = this.$$cookie('uid') || ''
      this.trackClick(
        200001,
        {
          surl: item.link || '',
          infotitle: item.title || '',
          citycode: this.citycode,
          fuid: uid
        },
        `surl: ${item.link}, infotitle: ${item.title}, citycode: ${this.citycode}, fuid: ${uid}`,
        121011908,
        `${index + 1}`
      )
    }
  },
  computed: {
    newPosters() {
      return this.posters.filter(ele => ele.link !== '' && ele.image !== '')
    }
  },
  components: {
    Swipe,
    SwipeItem
  }
}
</script>

<style lang="scss" scope>
@import '../../assets/css/mixin';
.poster {
  height: rem(320px);
  position: relative;
  a {
    display: block;
    height: 100%;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
// .mint-swipe-indicator.is-active
// 评论成功页
.comment-poster {
  height: rem(200px);
  img {
    height: rem(200px);
  }
}
</style>
<style lang="scss">
@import '../../assets/css/mixin';
.banner-home-ui {
  &.beforeLoading {
    // background: #f5f5f5;
  }
  &.noBanner {
    background: url('~@/assets/images/banner_bg@3x.jpg');
    background-size: 100% auto;
  }
  .mint-swipe-indicators {
    right: rem(40px);
    left: auto;
    bottom: rem(40px);
    transform: translateX(0);
  }
  .mint-swipe-indicator {
    width: rem(12px);
    height: rem(4px);
    opacity: 0.4;
    background: #ffffff;
    border-radius: rem(5px);
    margin: 0 rem(2px);
  }
  .mint-swipe-indicator.is-active {
    opacity: 1;
  }
}
</style>
